<template>
  <div class="place-search">
    <!-- <input
      type="text"
      v-model="search.address_line_1"
      placeholder="Enter an address to find a location near you"
      @keypress.enter="searchPlace"
      :disabled="searching"
    /> -->
    <gmap-autocomplete
      placeholder="Enter an address to find a location near you"
      @place_changed="setPlace"
      :disabled="searching"
      class="autocomplete"
      :value="search.address_line_1"
    >
    </gmap-autocomplete>
    <button class="filter-icon" @click.prevent="clear" v-if="search.address_line_1.length > 0">
      <span class="close-filter">&times;</span>
    </button>
  </div>
</template>

<script>
  export default {
    data: () => ({
      searching: false,
      filterIconCtrl: false,
      filterIcon: `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAgAAAAIABAMAAAAGVsnJAAAAA3NCSVQICAjb4U/gAAAACXBIWXMAAA9wAAAPcAEzbFVHAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAABtQTFRF////AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAeBnKPQAAAAh0Uk5TADE4SXCTqOBWhzETAAABe0lEQVR42u3cMQ2AMBRF0RICrGioAkQgAAlMzMhANjMLQxMS2n+OhLu/lxIAAAAAAAAAAAAAAAAAAAAAAAAAAEBNjuDSFZwAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACtBQgB2c6CwAAAAAAAAAAAAAAAAAAAAAAAAAAzerXaiyfBBjr+crdBRBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEECAd+GHkwAAAAAAAAAAAAAAAAAAAAAAAAAAQBBdLjQ3EmAqfcc9BRBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEEAAAQQQQAABBBBAAAEEEECAvxmOQlsCAAAAAAAAAAAAAAAAAAAAAAAAAADg4Qa3yzgMvNqcVQAAAABJRU5ErkJggg==`,
      search: {
        address_line_1: ''
      }
    }),
    methods: {
      setPlace (place) {
        this.search.address_line_1 = place.formatted_address ? place.formatted_address : place.name
        this.searchPlace()
      },
      searchPlace() {
        this.searching = true
        this.$geocoder.send(this.search, (res) => {
          this.searching = false
          this.$emit('input', res)
        }, error => {
          this.searching = false
          // eslint-disable-next-line no-console
          console.log(error)
        })
      },
      clear() {
        this.search.address_line_1 = '';
      }
    }
  }
</script>

<style>
  .place-search {
    padding: 4px;
    box-shadow: 0 0 4px rgba(0, 0, 0, .3);
    position: relative;
    background-color: #fff;
    font-family: Arial, Helvetica, sans-serif;
    overflow: hidden;
  }
  .place-search input[type="text"],
  .place-search input.autocomplete {
    font-size: 14px;
    width: calc(100% - 40px);
    border: none;
    padding: 8px 4px;
    position: relative;
    z-index: 2;
    background-color: transparent;
    font-family: Arial, Helvetica, sans-serif;
  }
  .place-search input[type="text"]:focus,
  .place-search input.autocomplete:focus {
    outline: none;
  }
  .place-search .filter-icon {
    background: none;
    border: none;
    padding: 0;
    margin: 0;
    width: 30px;
    height: 30px;
    vertical-align: middle;
    cursor: pointer;
  }
  .place-search .filter-icon:focus {
    outline: none;
  }
  .place-search .filter-icon img {
    max-width: 28px;
    max-height: 28px;
  }
  .place-search .filter-icon .close-filter {
    font-size: 32px;
    line-height: 1rem;
  }
</style>